<div class="white-box main-black mt-4 p-4 border-radius">
	<div class="row mb-4">
		<div class="col">
			<h4>
				{{'fleet_reports.truck_usage_charts' | translate}}
			</h4>
		</div>
	</div>

	<div class="row mb-4">
		<!-- years list -->
		<div class="col-sm-6 col-md-2 d-inline-flex">
			<ng-select [searchable]="false" class="mr-auto w-100" [items]="yearList" bindLabel="label" bindValue="id" placeholder="{{'site.year' | translate}}" name="year" [(ngModel)]="selectedYear" (ngModelChange)="selectYear()" [clearable]="false">
			</ng-select>
		</div>

		<!-- Monthly or Daily drop-down -->
		<div class="col-sm-6 col-md-2 d-inline-flex">
			<ng-select [searchable]="false" class="mr-auto w-100" [items]="periodTypes" bindLabel="label" bindValue="id" placeholder="{{'perf_analytic.period' | translate}}" name="period" [(ngModel)]="selectedPeriodType" (ngModelChange)="changePeriodType()" [clearable]="false">
			</ng-select>
		</div>

		<!-- graphs filter -->
		<div class="col-sm-6 col-md-2 d-inline-flex" *ngIf="selectedPeriodType !== 'daily'">
			<ng-select [searchable]="false" class="mr-auto w-100" [items]="graphTypes" bindLabel="label" bindValue="id" placeholder="{{'g.data' | translate}}" name="graph_type" [(ngModel)]="selectedGraphTypes" [clearable]="false">
			</ng-select>
		</div>

		<!-- charts toggle -->
		<div class="col-sm-6 col-md-2 d-inline-flex">
			<ng-select [searchable]="false" class="mr-auto w-100" [items]="chartsList" bindLabel="label" bindValue="id" placeholder="{{'g.chart' | translate}}" name="chart" [(ngModel)]="selectedCharts" [clearable]="false">
			</ng-select>
		</div>

		<div class="d-inline-flex ml-auto" *ngIf="!noData">
			<button  class="btn fa fa-print fa-lg" printTitle="{{'fleet_reports.truck_usage_charts' | translate}}" [useExistingCss]="true" printSectionId="truck_usage_charts" ngxPrint title="{{'g.print' | translate}}"></button>
			<button class="fa fa-upload btn" title="{{'g.export_to_csv' | translate}}" (click)="exportDataToCsv()"></button>
		</div>
	</div>

	<!-- charts -->
	<div id="truck_usage_charts" *ngIf="!noData">
		<app-print-filters title="fleet_reports.truck_usage_charts" [filters]="printFilters"></app-print-filters>
		<div class="row" *ngIf="['inuse_hours', 'all'].includes(selectedCharts)">
			<sct-charts
				*ngIf="(selectedGraphTypes == 'total' && chartsData.total_inuse_hours[selectedYear]) || (selectedGraphTypes == 'average' && chartsData.average_inuse_hours[selectedYear])"
				id="inuse_hours"
				title="{{(selectedGraphTypes == 'total' ? 'fleet_reports.total_inuse_hours' : 'fleet_reports.average_inuse_hours') | translate}}"
				[data]="selectedGraphTypes == 'total' ? chartsData.total_inuse_hours[selectedYear] : chartsData.average_inuse_hours[selectedYear]"
				[columnNames]="timeChartColumnNames"
				[options]="timeChartConfig"
				[type]="'ColumnChart'"
				[height]="500"
			></sct-charts>
		</div>
		<div class="row" *ngIf="['idle_hours', 'all'].includes(selectedCharts)">
			<sct-charts
				*ngIf="(selectedGraphTypes == 'total' && chartsData.total_idle_hours[selectedYear]) || (selectedGraphTypes == 'average' && chartsData.average_idle_hours[selectedYear])"
				id="idle_hours"
				title="{{(selectedGraphTypes == 'total' ? 'fleet_reports.total_idle_hours' : 'fleet_reports.average_idle_hours') | translate}}"
				[data]="selectedGraphTypes == 'total' ? chartsData.total_idle_hours[selectedYear] : chartsData.average_idle_hours[selectedYear]"
				[columnNames]="timeChartColumnNames"
				[options]="timeChartConfig"
				[type]="'ColumnChart'"
				[height]="500"
			></sct-charts>
		</div>
		<div class="row" *ngIf="['inuse_ah', 'all'].includes(selectedCharts)">
			<sct-charts
				*ngIf="(selectedGraphTypes == 'total' && chartsData.total_inuse_ah[selectedYear]) || (selectedGraphTypes == 'average' && chartsData.average_inuse_ah[selectedYear])"
				id="inuse_ah"
				title="{{(selectedGraphTypes == 'total' ? 'fleet_reports.total_inuse_ah' : 'fleet_reports.average_inuse_ah') | translate}}"
				[data]="selectedGraphTypes == 'total' ? chartsData.total_inuse_ah[selectedYear] : chartsData.average_inuse_ah[selectedYear]"
				[columnNames]="['Time', (selectedGraphTypes == 'total' ? 'fleet_reports.total_inuse_ah' : 'fleet_reports.average_inuse_ah') | translate]"
				[options]="chartObject.config"
				[type]="'ColumnChart'"
				[height]="500"
			></sct-charts>
		</div>
		<div class="row" *ngIf="['inuse_kwh', 'all'].includes(selectedCharts)">
			<sct-charts
				*ngIf="(selectedGraphTypes == 'total' && chartsData.total_inuse_kwh[selectedYear]) || (selectedGraphTypes == 'average' && chartsData.average_inuse_kwh[selectedYear])"
				id="inuse_kwh"
				title="{{(selectedGraphTypes == 'total' ? 'fleet_reports.total_inuse_kwh' : 'fleet_reports.average_inuse_kwh') | translate}}"
				[data]="selectedGraphTypes == 'total' ? chartsData.total_inuse_kwh[selectedYear] : chartsData.average_inuse_kwh[selectedYear]"
				[columnNames]="['Time', (selectedGraphTypes == 'total' ? 'fleet_reports.total_inuse_kwh' : 'fleet_reports.average_inuse_kwh') | translate]"
				[options]="chartObject.config"
				[type]="'ColumnChart'"
				[height]="500"
			></sct-charts>
		</div>
		<div class="row" *ngIf="['travel_lift_time', 'all'].includes(selectedCharts)">
			<sct-charts
				*ngIf="(selectedGraphTypes == 'total' && chartsData.total_travel_lift_time[selectedYear]) || (selectedGraphTypes == 'average' && chartsData.average_travel_lift_time[selectedYear])"
				id="travel_lift_time"
				title="{{(selectedGraphTypes == 'total' ? 'fleet_reports.total_travel_lift_time' : 'fleet_reports.average_travel_lift_time') | translate}}"
				[data]="selectedGraphTypes == 'total' ? chartsData.total_travel_lift_time[selectedYear] : chartsData.average_travel_lift_time[selectedYear]"
				[columnNames]="travelLiftTimeChartColumnNames"
				[options]="travelLiftTimeChartConfig"
				[type]="'ColumnChart'"
				[height]="500"
			></sct-charts>
		</div>
	</div>

	<div class="card-body" *ngIf="noData">
		<div class="alert alert-info">{{'g.no_data_to_show' | translate}}</div>
	</div>
</div>
